<template>
  <div class="pt-2 pb-5 py-4 d-flex flex-column flex-md-row align-items-center w-100" :class="alignClass">
    <!-- 우측: 페이지네이션 -->
    <nav aria-label="pagination" :class="navAlignClass">
      <ul class="pagination mb-0 gap-1">
        <li class="page-item" :class="{ disabled: disabled || page <= 1 }">
          <button class="page-link" @click="prev" aria-label="Previous">&laquo;</button>
        </li>

        <li v-for="n in pages" :key='`p-${n}`' class="page-item"
            :class="{ active: n === page, disabled: n === ELLIPSIS || disabled }">
          <button v-if="n !== ELLIPSIS" class="page-link" @click="go(n)">{{ n }}</button>
          <span v-else class="page-link">{{ ELLIPSIS }}</span>
        </li>

        <li class="page-item" :class="{ disabled: disabled || page >= pageCount }">
          <button class="page-link" @click="next" aria-label="Next">&raquo;</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    /** v-model:page */
    page: { type: Number, required: true },
    /** v-model:pageSize */
    pageSize: { type: Number, default: 10 },
    /** 전체 건수 */
    total: { type: Number, required: true },
    /** 선택 가능한 페이지 크기 */
    pageSizes: { type: Array, default: () => [5, 10, 20, 50] },
    /** 페이지 버튼 최대 길이(… 포함) */
    maxLength: { type: Number, default: 7 },
    /** 좌우 정렬: 'start' | 'center' | 'end' */
    align: { type: String, default: 'end' },
    /** 좌측 정보 영역(총 건수/페이지당) 표시 여부 */
    showInfo: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:page', 'update:pageSize'],
  data() {
    return { ELLIPSIS: '…' };
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil((this.total || 0) / this.pageSize));
    },
    alignClass() {
      switch (this.align) {
        case 'center': return 'justify-content-center';
        case 'end':    return 'justify-content-end';
        default:       return 'justify-content-start';
      }
    },
    navAlignClass() {
      return {
        'mx-auto': this.align === 'center', // 가운데
        'ms-auto': this.align === 'end',    // 오른쪽
      };
    },
    pages() {
      const total = this.pageCount;
      const current = Math.min(Math.max(1, this.page), total);
      const max = Math.max(5, this.maxLength); // 최소 5
      if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);

      const res = [];
      const left = Math.max(2, current - 1);
      const right = Math.min(total - 1, current + 1);

      res.push(1);
      if (left > 2) res.push(this.ELLIPSIS);
      for (let i = left; i <= right; i++) res.push(i);
      if (right < total - 1) res.push(this.ELLIPSIS);
      res.push(total);
      return res;
    },
  },
  methods: {
    go(n) {
      if (n === this.ELLIPSIS) return;
      if (n >= 1 && n <= this.pageCount && n !== this.page) {
        this.$emit('update:page', n);
      }
    },
    prev() {
      if (this.page > 1) this.$emit('update:page', this.page - 1);
    },
    next() {
      if (this.page < this.pageCount) this.$emit('update:page', this.page + 1);
    },
    onChangePageSize(e) {
      const size = Number(e.target.value) || this.pageSize;
      this.$emit('update:pageSize', size);
      this.$emit('update:page', 1); // 보통 첫 페이지로
    },
  },
};
</script>
